import { z } from 'zod';
import { CognitoSubSchema, TimestampSchema } from '../common.js';
import { Iso639_1Schema } from './agent.js';
/**
 * Media asset attached to an agent — see docs/data-model.md §4.8.
 * PK = TENANT#<tenantId>, SK = AGENT#<agentId>#MEDIA#<mediaId>
 */
export const AgentMediaSlotSchema = z.enum([
    'main-video',
    'main-video-hevc',
    'background-image',
    'poster',
]);
export const AgentMediaSchema = z.object({
    mediaId: z.string().uuid(),
    agentId: z.string().uuid(),
    slot: AgentMediaSlotSchema,
    /** Language this asset belongs to for language-specific slots; null for global assets. */
    lang: Iso639_1Schema.nullable().default(null),
    /** MIME type, e.g. "video/mp4" or "image/webp". */
    mime: z.string().min(1),
    /** S3 object key. */
    s3Key: z.string().min(1),
    /** File size in bytes. */
    bytes: z.number().int().positive(),
    /** Pixel width (images and video). */
    width: z.number().int().positive().optional(),
    /** Pixel height (images and video). */
    height: z.number().int().positive().optional(),
    /** Duration in seconds (video only). */
    durationSec: z.number().nonnegative().optional(),
    uploadedAt: TimestampSchema,
    uploadedBy: CognitoSubSchema,
});
//# sourceMappingURL=agentMedia.js.map